var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('img',{staticClass:"al-logo",attrs:{"src":require("@/assets/iqala_logo.svg")}}),_c('div',{staticClass:"auth-logo-title"},[_c('div',{staticClass:"alt-sub marg-b-10"},[_vm._v("Портал городских услуг")]),_c('div',{staticClass:"alt-main mb-0"},[_vm._v("Автоматизированное рабочее место")])])])
}]

export { render, staticRenderFns }